import React, { useEffect, useState, useRef } from 'react';
import '../styles/PublicationsDash.css';
import { FaPlusCircle, FaSearch } from 'react-icons/fa';
import { RiCheckFill, RiCloseFill, RiFileShield2Line, RiToggleFill, RiToggleLine } from 'react-icons/ri';
import { useSlideout } from '../../../hooks/SlideoutContext';
import { IoMdRefresh } from 'react-icons/io';
import axios from 'axios';
import config from '../../../constants/config';
import axiosPost from '../../../helper/axios-helper';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import DatePicker from 'react-datepicker';  
import 'react-datepicker/dist/react-datepicker.css';

export default function PublicationsDash() {
  const [publications, setPublications] = useState([
    // {
    //   id: 1,
    //   featured: 1,
    //   category: 'News',
    //   image: 'https://via.placeholder.com/150',
    //   title: 'New Caribbean Tourism Initiative',
    //   author: 'John Smith',
    //   content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam euismod, nisl eget ultricies aliquam, nunc nisl ultricies nunc.',
    //   c2a: 'https://example.com/read-more',
    //   views: 1250,
    //   active: 1,
    //   timestamp_last: 1656604800000, // July 1, 2022
    //   timestamp: 1656518400000 // June 30, 2022
    // },
    // {
    //   id: 2,
    //   featured: 0,
    //   category: 'Events',
    //   image: 'https://via.placeholder.com/150',
    //   title: 'Caribbean Cultural Festival 2022',
    //   author: 'Maria Rodriguez',
    //   content: 'Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.',
    //   c2a: 'https://example.com/festival',
    //   views: 850,
    //   active: 1,
    //   timestamp_last: 1656691200000, // July 2, 2022
    //   timestamp: 1656604800000 // July 1, 2022
    // },
    // {
    //   id: 3,
    //   featured: 1,
    //   category: 'Travel',
    //   image: 'https://via.placeholder.com/150',
    //   title: 'Top 10 Caribbean Destinations',
    //   author: 'David Johnson',
    //   content: 'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident.',
    //   c2a: 'https://example.com/destinations',
    //   views: 3200,
    //   active: 1,
    //   timestamp_last: 1656777600000, // July 3, 2022
    //   timestamp: 1656691200000 // July 2, 2022
    // },
    // {
    //   id: 4,
    //   featured: 0,
    //   category: 'Food',
    //   image: 'https://via.placeholder.com/150',
    //   title: 'Caribbean Cuisine Guide',
    //   author: 'Sarah Williams',
    //   content: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    //   c2a: 'https://example.com/cuisine',
    //   views: 1800,
    //   active: 0,
    //   timestamp_last: 1656864000000, // July 4, 2022
    //   timestamp: 1656777600000 // July 3, 2022
    // },
    // {
    //   id: 5,
    //   featured: 1,
    //   category: 'Culture',
    //   image: 'https://via.placeholder.com/150',
    //   title: 'Caribbean Music History',
    //   author: 'Robert Brown',
    //   content: 'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    //   c2a: 'https://example.com/music',
    //   views: 2100,
    //   active: 1,
    //   timestamp_last: 1656950400000, // July 5, 2022
    //   timestamp: 1656864000000 // July 4, 2022
    // }
  ]);
  
  const [loading, setLoading] = useState(false);
  const { openSlideout, closeSlideout } = useSlideout();

  const fetchPublications = () => {
    setLoading(true);
    axiosPost('admin/publications/fetch', {
    }, {}, (data) => {
      const { success, response } = data;
      if (success) {
        setPublications(data.data);
        console.log(data.data);
      } else {
        console.log("Error fetching publications:", response);
      }
      setLoading(false);
    });
  };

  const togglePublicationStatus = (id, currentStatus) => {
    const newStatus = currentStatus > 0 ? 0 : 1;
    
    const formData = new FormData();
    formData.append("id", id);
    formData.append("status", newStatus);
    
    axios.post(config.api.url + "admin/publication/toggle", formData, {
      crossdomain: true,
      headers: {
        api: config.api.key,
        auth: "b8GjLbLHDX9isF10ptWj",
        "Content-Type": "multipart/form-data"
      }
    })
    .then((json) => {
      const { success, response } = json.data;
      if (success) {
        fetchPublications();
      } else {
        console.log("Error toggling publication status:", response);
      }
    })
    .catch((error) => {
      console.error("Toggle status error:", error);
    });
  };

  useEffect(() => {
    fetchPublications();
  }, []);

  const EditPublicationItem = ({ publication, fetchPublications }) => {
    const { closeSlideout, toggleExpanded, isExpanded } = useSlideout();
    const [itemData, setItemData] = useState({
      id: publication.id,
      featured: publication.featured,
      category: publication.category,
      image: publication.image,
      title: publication.title,
      author: publication.author,
      content: publication.content,
      c2a: publication.c2a,
      active: publication.active,
      timestamp: publication.timestamp ? new Date(publication.timestamp * 1000) : new Date()
    });

    const [selectedImageFile, setSelectedImageFile] = useState(null);
    const [selectedImagePreview, setSelectedImagePreview] = useState(publication.image);
    const fileInputRef = useRef(null);

    // Handle input changes
    const handleChange = (e) => {
      const { name, value, type, checked } = e.target;
      setItemData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value
      }));
    };

    // Handle file selection
    const handleImageChange = (event) => {
      const file = event.target.files[0];
      if (file) {
        const imageUrl = URL.createObjectURL(file); // Create a temporary preview
        setSelectedImageFile(file);
        setSelectedImagePreview(imageUrl);
      }
    };

    // Open file input
    const handleSelectImage = () => {
      fileInputRef.current.click();
    };

    // Handle save changes
    const handleSaveChanges = () => {
      const formData = new FormData();
      
      // Check if this is an update or a new item
      const isNewItem = !itemData.id;
      
      // Only append ID if it's an update
      if (!isNewItem) {
        formData.append("id", itemData.id);
      }
      
      formData.append("category", itemData.category);
      formData.append("title", itemData.title);
      formData.append("author", itemData.author);
      formData.append("content", itemData.content);
      formData.append("c2a", itemData.c2a);
      formData.append("active", itemData.active ? 1 : 0);
      
      // Convert date to Unix timestamp (seconds)
      if (itemData.timestamp) {
        const timestamp = Math.floor(itemData.timestamp.getTime() / 1000);
        formData.append("timestamp", timestamp);
      }
      
      if (selectedImageFile) {
        formData.append("image", selectedImageFile);
      }
      
      // Determine the endpoint based on whether it's a new item or an update
      const endpoint = isNewItem 
        ? "admin/publication/add" 
        : "admin/publication/edit";
      
      axios.post(config.api.url + endpoint, formData, {
        crossdomain: true,
        headers: {
          api: config.api.key,
          auth: "b8GjLbLHDX9isF10ptWj",
          "Content-Type": "multipart/form-data"
        }
      })
      .then((json) => {
        const { success, response } = json.data;
        if (success) {
          closeSlideout();
          fetchPublications();
        } else {
          console.log("Error:", response);
        }
      })
      .catch((error) => {
        console.error(isNewItem ? "Add error:" : "Update error:", error);
      });
    };

    return (
      <div className="PublicationEditForm">
        <div className="PublicationEditFormRow">
          <div className="PublicationEditFormLabel">Title</div>
          <input
            type="text"
            name="title"
            value={itemData.title}
            onChange={handleChange}
            className="PublicationEditFormInput"
          />
        </div>

        <div className="PublicationEditFormRow">
          <div className="PublicationEditFormLabel">Category</div>
          <input
            type="text"
            name="category"
            value={itemData.category}
            onChange={handleChange}
            className="PublicationEditFormInput"
          />
        </div>

        <div className="PublicationEditFormRow">
          <div className="PublicationEditFormLabel">Author</div>
          <input
            type="text"
            name="author"
            value={itemData.author}
            onChange={handleChange}
            className="PublicationEditFormInput"
          />
        </div>

        <div className="PublicationEditFormRow ContentRow">
          <div className="PublicationEditFormLabel">
            Content
            <button
              type="button"
              onClick={toggleExpanded}
              className="PublicationEditFormExpandButton"
            >
              {isExpanded ? 'Collapse Width' : 'Expand Width'}
            </button>
          </div>
          <ReactQuill
            theme="snow"
            value={itemData.content}
            onChange={(content) => {
              setItemData(prev => ({
                ...prev,
                content: content
              }));
            }}
            modules={{
              toolbar: [
                ['bold', 'italic', 'underline', 'strike'],
                [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                ['link'],
                ['clean']
              ],
            }}
            className="PublicationEditFormTextarea"
          />
        </div>

        <div className="PublicationEditFormRow">
          <div className="PublicationEditFormLabel">Call to Action URL</div>
          <input
            type="text"
            name="c2a"
            value={itemData.c2a}
            onChange={handleChange}
            className="PublicationEditFormInput"
          />
        </div>

        <div className="PublicationEditFormRow" style={{width: '100%'}}>
          <div className="PublicationEditFormLabel">Publication Date</div>
          <DatePicker
            selected={itemData.timestamp}
            onChange={(date) => {
              setItemData(prev => ({
                ...prev,
                timestamp: date
              }));
            }}
            showTimeSelect
            timeFormat="HH:mm"
            timeIntervals={15}
            timeCaption="time"
            dateFormat="MMMM d, yyyy h:mm aa"
            className="PublicationEditFormInput"
          />
        </div>

        <div className="PublicationEditFormRow">
          <div className="PublicationEditFormLabel">Image</div>
          <div className="PublicationEditFormImagePreview">
            {selectedImagePreview && (
              <img
                src={selectedImagePreview}
                alt="Preview"
                className="PublicationEditFormImagePreviewImg"
              />
            )}
            <button
              onClick={handleSelectImage}
              className="PublicationEditFormImageButton"
            >
              Select Image
            </button>
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleImageChange}
              accept="image/*"
              style={{ display: 'none' }}
            />
          </div>
        </div>

        <div className="PublicationEditFormActions">
          <button
            onClick={closeSlideout}
            className="PublicationEditFormButton Cancel"
          >
            Cancel
          </button>
          <button
            onClick={handleSaveChanges}
            className="PublicationEditFormButton Save"
          >
            Save Changes
          </button>
        </div>
      </div>
    );
  };

  const formatDate = (timestamp) => {
    // Convert Unix timestamp (seconds) to milliseconds for the Date constructor
    const date = new Date(timestamp * 1000);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <div className="PublicationsDashWrapper">
      <div className="PublicationsDashHeader">
        <div className="PublicationsDashHeaderTitle">
          <h2>Publications</h2>
          <p>Manage your publications</p>
        </div>
        <div className="PublicationsDashHeaderActions">
          {/* <div className="PublicationsDashHeaderSearch">
            <FaSearch className="PublicationsDashHeaderSearchIcon" />
            <input
              type="text"
              placeholder="Search publications..."
              className="PublicationsDashHeaderSearchInput"
            />
          </div> */}
          <button
            className="PublicationsDashHeaderButton Refresh"
            onClick={fetchPublications}
          >
            <IoMdRefresh />
            <span>Refresh</span>
          </button>
          <button
            className="PublicationsDashHeaderButton Add"
            onClick={() => {
              openSlideout({
                title: 'Add New Publication',
                content: <EditPublicationItem 
                  publication={{
                    id: null,
                    featured: 0,
                    category: '',
                    image: '',
                    title: '',
                    author: '',
                    content: '',
                    c2a: '',
                    active: 1,
                    views: 0,
                    timestamp_last: Date.now(),
                    timestamp: Date.now()
                  }} 
                  fetchPublications={fetchPublications}
                />
              });
            }}
          >
            <FaPlusCircle />
            <span>Add New</span>
          </button>
        </div>
      </div>

      <div className="PublicationsDashContent">
        {loading ? (
          <div className="PublicationsDashLoading">Loading publications...</div>
        ) : (
          <>
            <div className="PublicationsContentNavigation">
              <div className="PublicationsContentNavigationItem First">Status</div>
              <div className="PublicationsContentNavigationItem Image">Image</div>
              <div className="PublicationsContentNavigationItem Title">Title</div>
              <div className="PublicationsContentNavigationItem Category">Category</div>
              <div className="PublicationsContentNavigationItem Author">Author</div>
              <div className="PublicationsContentNavigationItem Date">Date</div>
            </div>
            <div className="PublicationsScroll">
              {publications.map((item) => (
                <div className="PublicationItem" key={item.id}>
                  <div className="PublicationItemDetailsText First Active">
                    <span className={`PublicationItemDetailsTextOption Circle ${item.active > 0 ? 'Success' : 'Error'}`}>
                      {item.active > 0
                        ? <RiCheckFill style={{ fontSize: 12 }} />
                        : <RiCloseFill style={{ fontSize: 12 }} />
                      }
                    </span>
                  </div>
                  <div className="PublicationItemDetailsText Image">
                    <div 
                      className="PublicationItemDetailsTextImage" 
                      style={{ backgroundImage: `url(${item.image})` }} 
                    />
                  </div>
                  <div className="PublicationItemDetailsText Title Bold">{item.title}</div>
                  <div className="PublicationItemDetailsText Category">{item.category}</div>
                  <div className="PublicationItemDetailsText Author">{item.author}</div>
                  <div className="PublicationItemDetailsText Date">{formatDate(item.timestamp)}</div>

                  <div className="PublicationItemOptions">
                    <a 
                      onClick={() => togglePublicationStatus(item.id, item.active)} 
                      className={`PublicationItemOptionsButton ${item.active > 0 ? 'DeleteInverted' : 'AddInverted'}`}
                    >
                      {item.active > 0
                        ? <RiToggleFill style={{ fontSize: 14 }} />
                        : <RiToggleLine style={{ fontSize: 14 }} />
                      }
                      <span className="PublicationItemOptionsButtonText">
                        {item.active > 0 ? 'Deactivate' : 'Activate'}
                      </span>
                    </a>

                    <a 
                      onClick={() => {
                        openSlideout({
                          title: 'Edit Publication',
                          content: <EditPublicationItem publication={item} fetchPublications={fetchPublications}/>
                        });
                      }} 
                      className="PublicationItemOptionsButton Edit"
                    >
                      <RiFileShield2Line style={{ fontSize: 14 }} />
                      <span className="PublicationItemOptionsButtonText">Edit</span>
                    </a>
                  </div>
                </div>
              ))}
            </div>
            <div className="PublicationsPaginationWrapper">
              {/* Pagination will be added here when needed */}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
